import React from 'react'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import FeatureL2 from '../../Componet/Feature/FeatureL2'
import AboutL3 from '../../Componet/About/AboutL3'
import TestimonialL4 from '../../Componet/Testimonial/TestimonialL4'
import BlogL3 from '../../Componet/Blog/BlogL3'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import FloatingPromoVideo from '../../Componet/VideoBox/FloatingPromoVideo'

const AboutUs = () => {
  return (
    <>
      <HerosectionHeader name={"AboutUS"} folder1={"Pages"} folder2={"Company"} />
      <FloatingPromoVideo inline={false} />
      <div className="page-content">
        <FeatureL2 />
        <AboutL3 />
        {/* <TestimonialL4 /> */}
        <BlogL3 />
        <NewsletterL1 />
      </div>
    </>
  )
}

export default AboutUs
